import React from 'react';
import { View, Text } from 'react-native';
import i18n from '@shared/i18n';
import { Head } from '@shared/components/head';
import { AppointmentCard } from 'app/_modules/core/components/home/AppointmentCard';
import { TeleassistancePendingContent } from 'app/_modules/core/components/home/TeleassistanceRequestCard/TeleassistancePendingContent';
import { mapModalityToType, mapHistoryStatusToCardStatus } from 'app/_modules/core/utils/appointment';
import { APPOINTMENT_STATUS } from 'app/_modules/core/constants/appointmentModality';
import { MonthGroup } from '../types/Visits';
import { useNavigation } from '@react-navigation/native';

const getMonthYearLabel = (monthNumber: string, year: string) => {
    const date = new Date(parseInt(year, 10), parseInt(monthNumber, 10) - 1);
    const monthName = new Intl.DateTimeFormat(i18n.language, { month: 'long' }).format(date);
    return `${monthName.charAt(0).toUpperCase() + monthName.slice(1)} ${year}`;
};

interface Props {
    title: string;
    monthGroups: MonthGroup[];
    onRequestCancel: (appointmentId: string) => void;
    isCancelling: boolean;
}

export const VisitsPeriodSection: React.FC<Props> = ({
    title,
    monthGroups,
    onRequestCancel,
    isCancelling,
}) => {
    const navigation = useNavigation<any>();

    return (
        <View className="mb-8">
            <Head type="h3" className="mb-3">{title}</Head>

            {monthGroups.map(group => (
                <View key={`${group.month}-${group.year}`} className="mb-6">
                    <Text className="text-base font-medium mb-3 text-gray-700">
                        {getMonthYearLabel(group.month, group.year)}
                    </Text>
                    {[...group.appointments].reverse().map(appointment => {
                        if (appointment.status === APPOINTMENT_STATUS.TO_BE_SCHEDULED) {
                            return (
                                <View key={appointment.id} className="border border-gray-300 rounded-3xl p-4 bg-white mb-3">
                                    <TeleassistancePendingContent
                                        isCancelled={false}
                                        createdAt={appointment.createdAt ?? appointment.date}
                                        canCancel={true}
                                        requestId={appointment.id}
                                        onRequestCancel={onRequestCancel}
                                        isCancelling={isCancelling}
                                        onView={() => navigation.navigate('TeleassistanceDetailScreen', { appointmentId: appointment.id })}
                                    />
                                </View>
                            );
                        }
                        return (
                            <AppointmentCard
                                key={appointment.id}
                                type={mapModalityToType(appointment.modality)}
                                status={mapHistoryStatusToCardStatus(appointment.status)}
                                time={appointment.time}
                                date={appointment.date}
                                activityName={appointment.exam?.label ?? appointment.modality}
                                professional={appointment.doctor ? {
                                    fullName: `${appointment.doctor.firstName} ${appointment.doctor.lastName}`.trim(),
                                    title: appointment.doctor.title,
                                } : undefined}
                            />
                        );
                    })}
                </View>
            ))}
        </View>
    );
};
